import { css } from '@linaria/atomic';

export type TextAlignment = 'left' | 'center' | 'right' | 'inherit';

const left = css`
  text-align: left;
`;
const center = css`
  text-align: center;
`;
const right = css`
  text-align: right;
`;
const inherited = css`
  text-align: inherit;
`;

const TEXT_ALIGN_CLASS: Record<TextAlignment, string> = {
  left,
  center,
  right,
  inherit: inherited,
};

export const getTextAlignClassName = (align: TextAlignment) => TEXT_ALIGN_CLASS[align];
